const loadView = (view) => {
  return () => import(/* webpackChunkName: "view-[request]" */ '../views/' + view + '.vue')
}

export {
  loadView
}
